import { useState } from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PLAN_LIST, SERVICE_LIST } from "@/lib/plans";
import { PayDialog } from "./PayDialog";

export const PlanCards = ({ current, onPaid }) => {
  const { user } = useAuth();
  const [order, setOrder] = useState(null);
  const [period, setPeriod] = useState("month");
  const artist = user && user.role === "artist";
  const yr = period === "year";
  return (
    <>
      <div className="mb-6 flex items-center gap-3" data-testid="billing-toggle">
        <div className="flex rounded-full border border-white/10 p-1">
          {[["month", "Monthly"], ["year", "Yearly"]].map(([k, l]) => <button key={k} onClick={() => setPeriod(k)} data-testid={`billing-${k}`} className={`rounded-full px-5 py-2 font-mono text-[11px] uppercase tracking-widest ${period === k ? "bg-[#FF2E63] text-white" : "text-slate-400"}`}>{l}</button>)}
        </div>
        <span className="rounded-full border border-[#FFB800]/50 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-[#FFB800]">Yearly: 2 months free</span>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {PLAN_LIST.map((p) => {
          const hot = p.id === "artist";
          const mine = current === p.id;
          return (
            <div key={p.id} data-testid={`plan-card-${p.id}`} className={`panel relative flex flex-col p-7 ${hot ? "border-[#FF2E63]/60 glow-crimson" : ""}`}>
              <span className={`label-mono ${hot ? "!text-[#FF2E63]" : ""}`}>{p.tag}</span>
              <h3 className="mt-3 font-display text-3xl font-black uppercase">{p.name}</h3>
              <div className="mt-4 flex items-end gap-1"><span className="led text-5xl font-bold" data-testid={`plan-price-${p.id}`}>€{yr && p.yearly ? p.yearly.toFixed(2) : p.price}</span>{p.price > 0 && <span className="pb-1 text-sm text-slate-500">{yr ? "/year" : "/month"}</span>}</div>
              {yr && p.yearly && <div className="mt-1 font-mono text-[11px] text-[#00F5D4]">= €{(p.yearly / 12).toFixed(2)}/month · save €{(p.price * 12 - p.yearly).toFixed(2)}</div>}
              <ul className="mt-6 flex-1 space-y-3">
                {p.features.map((f) => <li key={f} className="flex gap-2 text-sm text-slate-300"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[#00F5D4]" />{f}</li>)}
              </ul>
              {mine ? <div className="mt-7 rounded-full border border-[#00F5D4]/50 py-3 text-center font-display text-sm font-bold text-[#00F5D4]" data-testid={`plan-current-${p.id}`}>Your current plan</div>
                : p.price === 0 ? <Link to={artist ? "/dashboard" : "/join"} className="btn-ghost mt-7" data-testid={`plan-cta-${p.id}`}>{artist ? "Included" : "Join free"}</Link>
                : artist ? <button className={hot ? "btn-hot mt-7" : "btn-ghost mt-7"} data-testid={`plan-cta-${p.id}`} onClick={() => setOrder({ kind: "plan", item: p.id, period, label: `${p.name} plan — ${yr ? "yearly" : "monthly"}`, price: yr ? p.yearly.toFixed(2) : p.price })}>Go {p.name}</button>
                : <Link to="/join" className={hot ? "btn-hot mt-7" : "btn-ghost mt-7"} data-testid={`plan-cta-${p.id}`}>Start free, upgrade later</Link>}
            </div>
          );
        })}
      </div>
      <PayDialog order={order} onClose={() => setOrder(null)} onPaid={onPaid} />
    </>
  );
};

export const ServiceCards = ({ tracks = [], onPaid }) => {
  const { user } = useAuth();
  const [order, setOrder] = useState(null);
  const artist = user && user.role === "artist";
  return (
    <>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICE_LIST.map((s) => (
          <div key={s.id} data-testid={`service-card-${s.id}`} className="panel flex flex-col p-6">
            <h3 className="font-display text-xl font-bold">{s.name}</h3>
            <p className="mt-2 flex-1 text-sm text-slate-400">{s.desc}</p>
            <div className="mt-5 flex items-center justify-between">
              <span className="led text-2xl font-bold">€{s.price}</span>
              {artist ? <button className="btn-ghost !px-4 !py-2 text-sm" data-testid={`service-buy-${s.id}`}
                onClick={() => setOrder({ kind: "service", item: s.id, label: s.name, price: s.price, track_id: tracks.find((t) => t.status === "approved")?.id })}>Buy</button>
                : <Link to="/join" className="btn-ghost !px-4 !py-2 text-sm" data-testid={`service-join-${s.id}`}>Join to buy</Link>}
            </div>
          </div>
        ))}
      </div>
      <PayDialog order={order} onClose={() => setOrder(null)} onPaid={onPaid} />
    </>
  );
};
